import { render, staticRenderFns } from "./SettingsAlias.vue?vue&type=template&id=0cc64a63"
import script from "./SettingsAlias.vue?vue&type=script&lang=js"
export * from "./SettingsAlias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports